import { useNuxtApp } from '#app'

const MAX_STRING_LENGTH = 500
const MAX_DEPTH = 2

function truncateString(value) {
  if (typeof value !== 'string') return value
  if (value.length <= MAX_STRING_LENGTH) return value
  return `${value.slice(0, MAX_STRING_LENGTH)}...[truncated]`
}

function serializeValue(value, depth = 0) {
  if (value === null || value === undefined) return value

  if (typeof value === 'string') return truncateString(value)
  if (typeof value === 'number' || typeof value === 'boolean') return value

  if (value instanceof Error) {
    return {
      name: value.name,
      message: truncateString(value.message),
      stack: truncateString(value.stack || ''),
    }
  }

  if (depth >= MAX_DEPTH) {
    return truncateString(String(value))
  }

  if (Array.isArray(value)) {
    return value.slice(0, 20).map(item => serializeValue(item, depth + 1))
  }

  if (typeof value === 'object') {
    return Object.keys(value)
      .slice(0, 30)
      .reduce((acc, key) => {
        acc[key] = serializeValue(value[key], depth + 1)
        return acc
      }, {})
  }

  return truncateString(String(value))
}

function getRouteContext() {
  try {
    const nuxtApp = useNuxtApp()
    const route = nuxtApp?.$router?.currentRoute?.value

    return {
      routePath: route?.path || null,
      routeName: route?.name || null,
      routeFullPath: route?.fullPath || null,
    }
  }
  catch {
    return {
      routePath: null,
      routeName: null,
      routeFullPath: null,
    }
  }
}

export function reportAuthIssue(event, context = {}, error = null) {
  if (!import.meta.client) return

  const serializedContext = serializeValue(context)
  const routeContext = getRouteContext()
  const payload = {
    event,
    timestamp: new Date().toISOString(),
    ...routeContext,
    ...serializedContext,
  }

  if (error) {
    console.error(`[auth] ${event}`, payload, serializeValue(error))
    return
  }

  console.warn(`[auth] ${event}`, payload)
}
